export default __webpack_public_path__ + "static/media/tab1_1.a9e50c98.png";